import React, { useEffect, useState, useRef, useCallback } from 'react';
import Navbar from '../../navbar';
import Header from '../../header';
import { useDispatch, useSelector } from 'react-redux';
import { createNotification } from "../../../store/reducers/notificationSlice";
import { fetchApplication } from '../../../store/reducers/applicationSlice'
import classes from '../appForm/style.module.css'
import { useParams } from 'react-router-dom';
import { setFormFieldData, hideAllPagesExceptCurrentFormPage } from '../../../utility/utility';
import { updateApplicationData, safePdf } from '../../../store/reducers/applicationSlice';
import { getSignature, getAttachments } from '../../../store/reducers/fileSlice';
import DescripanciesBox from './discepancies-box';
// import Form from './form';
import FormHeader from '../forms/formHeader/formHeader';
import AddAttachment from './attachments';
import FormLoader from '../forms/formLoader';
import { useNavigate } from "react-router-dom";

const DiscrepanciesGbView = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const authToken = user.access_token;
    const params = useParams();
    const application = useSelector((state) => state.applications.application);
    const [pageIds, setPageIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [formIds, setFormIds] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [applicationDicrepancies, setApplicationDiscrepancies] = useState(null);
    const [selectedFieldData, setSelectedFieldData] = useState({});
    const [loading, setLoading] = useState(true);

    // Debug log for selectedFieldData changes (can be removed in production)
    useEffect(() => {
        console.log('selectedFieldData updated:', selectedFieldData);
    }, [selectedFieldData]);

    const [inputFields, setInputFields] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [signatureIds, setSignatureIds] = useState([]);
    const [signatureImage, setSignatureImage] = useState('')
    const [showAttachments, setShowAttachments] = useState(false);
    const navigate = useNavigate();

    // Reference to attachments component's saveChanges function
    const attachmentsRef = useRef(null);

    // Clear data when application ID changes to prevent showing previous application data
    useEffect(() => {
        console.log('Application ID changed, clearing data for:', params.id);
        setLoading(true);
        setIsLoaded(false);
        setCurrentPage(1);
        setShowAttachments(false);
        // Reset user interaction flag
        console.log('Data cleared for application ID:', params.id);
    }, [params.id]);


    useEffect(() => {
        if (dispatch && params.id && authToken) {
            console.log('Fetching application data for ID:', params.id);
            setLoading(true);
            dispatch(fetchApplication({ id: params.id, accessToken: authToken }))
                .then(() => {
                    console.log('Application data fetched successfully');
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error fetching application:', error);
                    setLoading(false);
                });
        }
    }, [dispatch, params.id, authToken])


    useEffect(() => {
        const timestamp = new Date().toLocaleTimeString();
        console.log(`[${timestamp}] Discrepancies useEffect triggered - isLoaded:`, isLoaded, 'user:', !!user, 'application:', !!application);
        const runAsyncFunctions = async () => {
            if (isLoaded && user && application) {
                console.log(`[${timestamp}] Running async functions for discrepancies application:`, application.name);

                setTimeout(async () => {
                    try {
                        await setFormFieldData((application.json_data));
                        console.log('Form field data set successfully');
                        console.log("application.discrepancies:", application.discrepancies);
                        setApplicationDiscrepancies(application.discrepancies);
                        setSelectedFieldData(application.discrepancies);
                        setInputFields(application.json_data);
                    } catch (error) {
                        console.error('Error setting form field data:', error);
                    }
                }, 500);

                let userId = application.user_id || user.user.id
                console.log('Using userId for file operations:', userId);

                // Use Promise.allSettled to handle both API calls gracefully
                const [signatureResult, attachmentsResult] = await Promise.allSettled([
                    getSignature({ userId: userId, applicationId: params.id, authToken }),
                    getAttachments({ userId: userId, applicationId: params.id, authToken })
                ]);

                // Handle signature result
                if (signatureResult.status === 'fulfilled' && signatureResult.value) {
                    setSignatureImage(signatureResult.value);
                    console.log('Signature loaded successfully');
                } else {
                    const error = signatureResult.reason;
                    if (error && error.message === 'NOT_FOUND') {
                        console.log('No signature found for this application (404 expected)');
                    } else if (error && error.message === 'SERVER_ERROR') {
                        console.log('Server error loading signature (500) - will retry later');
                    } else {
                        console.log('Error loading signature:', error?.message || 'Unknown error');
                    }
                }

                // Handle attachments result
                if (attachmentsResult.status === 'fulfilled' && attachmentsResult.value) {
                    const files = attachmentsResult.value.map(filename => ({ name: filename }));
                    setUploadedFiles(files);
                    console.log('Attachments loaded successfully:', files);
                } else {
                    const error = attachmentsResult.reason;
                    if (error && error.message === 'NOT_FOUND') {
                        console.log('No attachments found for this application (404 expected)');
                    } else if (error && error.message === 'SERVER_ERROR') {
                        console.log('Server error loading attachments (500) - will retry later');
                    } else {
                        console.log('Error loading attachments:', error?.message || 'Unknown error');
                    }
                    setUploadedFiles([]);
                }
            }
        };

        runAsyncFunctions();
    }, [isLoaded, user, application, authToken, params.id]);



    // click handler for discrepancies - GB view (read-only, no field selection)
    const handleInputChange = React.useCallback((event) => {
        // GB view typically doesn't allow field selection for discrepancies
        // This handler is kept for compatibility but doesn't modify fields
        console.log('Field clicked in GB view (read-only):', event.target.id);
    }, []);

    // attach/remove listeners for discrepancies and restore highlighting
    useEffect(() => {
        console.log('Attaching listeners to formIds:', formIds); // Debug log
        formIds.forEach((id) => {
            const inputField = document.getElementById(id);
            if (inputField) {
                inputField.removeEventListener('click', handleInputChange);
                inputField.addEventListener('click', handleInputChange);
                console.log('Attached listener to:', id); // Debug log

                // Restore red highlighting for fields that have discrepancies
                const fieldId = 'dis_' + id;
                if (selectedFieldData[fieldId]) {
                    inputField.style.backgroundColor = '#ff0000';
                    console.log('Restored highlighting for:', fieldId); // Debug log
                }
            } else {
                console.log('Element not found for id:', id); // Debug log
            }
        });
        return () => {
            formIds.forEach((id) => {
                const inputField = document.getElementById(id);
                if (inputField) {
                    inputField.removeEventListener('click', handleInputChange);
                }
            });
        };
    }, [formIds, handleInputChange, selectedFieldData]);

    // Restore highlighting when selectedFieldData changes (for page reload/navigation back)
    useEffect(() => {
        if (Object.keys(selectedFieldData).length > 0 && formIds.length > 0) {
            console.log('Restoring highlighting for existing discrepancies:', selectedFieldData);
            Object.keys(selectedFieldData).forEach(fieldId => {
                const formFieldId = fieldId.replace('dis_', '');
                const inputField = document.getElementById(formFieldId);
                if (inputField) {
                    inputField.style.backgroundColor = '#ff0000';
                    console.log('Restored highlighting for field:', formFieldId);
                }
            });
        }
    }, [selectedFieldData, formIds, isLoaded]);

    // inject signature with improved handling
    useEffect(() => {
        if (formIds.length > 0 && signatureImage && isLoaded) {
            formIds.forEach((id) => {
                const inputField = document.getElementById(id);
                if (inputField?.type === 'image') {
                    const computed = window.getComputedStyle(inputField);
                    const originalWidth = parseFloat(computed.width) || 0;
                    const originalTop = parseFloat(computed.top) || 0;
                    const height = (originalWidth * 114) / 179;

                    inputField.style.height = height + 'px';
                    inputField.style.top = originalTop - height + 20 + 'px';
                    inputField.src = signatureImage;
                    inputField.style.objectFit = 'contain';
                    inputField.style.pointerEvents = 'none';
                    // setImageData(signatureImage); // Removed - imageData state not needed
                }
            });
        }
    }, [signatureImage, isLoaded, formIds])

    // Handle signature display in form - similar to app-edit.js
    useEffect(() => {
        if (signatureImage && signatureIds.length > 0) {
            console.log('Displaying signature in form:', signatureImage);
            signatureIds.forEach(id => {
                const imageInput = document.getElementById(id);
                if (imageInput && imageInput.type === 'image') {
                    // Directly set the src of the image input
                    let originalWidth = window.getComputedStyle(imageInput).width.replace("px", "");
                    let originalTop = window.getComputedStyle(imageInput).top.replace("px", "");
                    let height = (originalWidth * 114) / 179;
                    imageInput.style.height = height + "px";
                    imageInput.style.top = (originalTop - height) + 20 + "px";
                    imageInput.src = signatureImage;
                    imageInput.style.objectFit = 'contain';
                    imageInput.style.pointerEvents = 'none';
                }
            });
        }
    }, [signatureImage, signatureIds]);

    useEffect(() => {
        if (pageIds) {
            hideAllPagesExceptCurrentFormPage(pageIds, currentPage);
        }
    }, [pageIds, currentPage])

    const handleFormInputChange = useCallback((event) => {
        const { id, value } = event.target;
        console.log("🚀 ~ handleFormInputChange ~ const:", id, value)

        setInputFields(prevInputFields => ({
            ...prevInputFields,
            [id]: value,
        }));
        console.log('Input field changed:', inputFields); // Debug log
    }, [inputFields]);

    const handleCheckBoxChange = useCallback((event) => {
        const { id, checked, value } = event.target;

        setInputFields(prevInputFields => {
            // If the checkbox is checked, add it to inputFields
            if (checked) {
                return {
                    ...prevInputFields,
                    [id]: value,
                };
            } else {
                // If the checkbox is unchecked, remove it from inputFields
                const { [id]: removedValue, ...remainingFields } = prevInputFields;
                return remainingFields;
            }
        })
    }, []);

    const attachEventHandlers = useCallback(() => {
        let tempSignatureIds = []

        formIds.forEach(id => {
            const inputField = document.getElementById(id);
            if (inputField.type === 'image') {
                tempSignatureIds.push(id);
            } else if (inputField.type === 'checkbox') {
                inputField.addEventListener('change', handleCheckBoxChange)
            } else {
                // For discrepancies page, we only handle form input changes, not clicks
                // The click handlers for discrepancies are handled separately
                inputField.addEventListener('change', handleFormInputChange);
            }
        });
        setSignatureIds(tempSignatureIds);
    }, [formIds, handleCheckBoxChange, handleFormInputChange]);

    useEffect(() => {
        if (formIds.length > 0) {
            attachEventHandlers();
            console.log('Event handlers attached for formIds:', formIds);
        }
    }, [formIds.length, attachEventHandlers, formIds]);

    useEffect(() => {
        console.log('Input fields updated:', inputFields);
    }, [inputFields]);

    const handleSubmitWithLoading = async (e) => {
        let htmlForm = document.getElementById("DocumentPDF").outerHTML;
        htmlForm = removeDisplayNoneByIds(htmlForm, pageIds);

        let newStatus = application?.state;
        let targetRoute = '/discrepancies-gb'; // default for employee

        // -----------------------------
        // ONLY TWO CONDITIONS NOW
        // -----------------------------
        if (user?.user?.user_role === 'company_admin') {
            newStatus = 'in_process';
            targetRoute = '/in-process-applications';

        } else if (user?.user?.user_role === 'employee') {
            newStatus = 'descrepency_GB_Company';
            targetRoute = '/discrepancies-gb';
        }

        // Update application status
        await dispatch(updateApplicationData({
            token: authToken,
            id: params.id,
            json_data: inputFields,
            userId: user.user.id,
            files: uploadedFiles,
            form: application.name,
            state: newStatus
        }));

        dispatch(createNotification({
            user_id: application?.user_id || application?.userId,
            applicationId: params.id,
            applicationName: application.name,
            status: newStatus,
            accessToken: authToken,
            sendToCompanyAdmins: true
        }))

        // Redirect
        navigate(targetRoute);

        // Save PDF
        dispatch(safePdf({
            htmlForm,
            user: { id: application.user_id },
            id: params.id,
            token: authToken
        }));
    };


    function removeDisplayNoneByIds(htmlContent, ids) {
        // Parse the HTML string into a DOM structure
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');

        // Loop through the array of IDs
        ids.forEach(id => {
            const element = doc.getElementById(id);
            if (element && element.style.display === 'none') {
                element.style.display = '';  // Remove the 'display: none' style
            }
        });
        // JSON.parse(formData);
        Object.entries(inputFields).forEach(([id, value]) => {
            // Get the input element by ID
            const element = doc.getElementById(id);

            // Check if the element exists and is an input field
            if (element) {
                const tagName = element.tagName.toLowerCase();
                if (tagName === 'input' || tagName === 'textarea') {
                    // Use setAttribute to set the value attribute
                    element.setAttribute('value', value);

                    // For textarea, also update the text content directly
                    if (tagName === 'textarea') {
                        element.textContent = value;
                    }
                }
            }
            if (element.type === 'checkbox') {
                // Set the checked state of the checkbox
                element.setAttribute('checked', true);
            }
        });

        const modifiedHtmlContent = new XMLSerializer().serializeToString(doc);
        return modifiedHtmlContent;
    };

    const previousPage = () => {
        if (currentPage === pageIds.length + 1) {
            setShowAttachments(false);
            showDiv(currentPage - 1);
            setCurrentPage(currentPage - 1)
        } else {
            if (currentPage - 1 >= 1) {
                hideDiv(currentPage);
                showDiv(currentPage - 1);
                setCurrentPage(currentPage - 1);
            }
        }
    }


    const nextPage = () => {
        if (currentPage + 1 <= pageIds.length) {
            hideDiv(currentPage);
            showDiv(currentPage + 1);
            setCurrentPage(currentPage + 1);
        } else if (currentPage + 1 <= pageIds.length + 1) {
            hideDiv(currentPage);
            setCurrentPage(currentPage + 1);
            setShowAttachments(true);
        }
    }
    const hideDiv = (pageNo) => {
        const pageDiv = document.getElementById("page" + pageNo);
        pageDiv.style.display = "none";
    }

    const showDiv = (pageNo) => {
        const pageDiv = document.getElementById("page" + pageNo);
        pageDiv.style.display = "";
    }

    const handlePageChange = (number) => {
        if (number > 0 && number <= pageIds.length + 1) {
            if (number === pageIds.length + 1) {
                hideDiv(currentPage);
                setCurrentPage(number);
                setShowAttachments(true);
            } else {
                if (currentPage === pageIds.length + 1) {
                    setShowAttachments(false)
                    showDiv(number)
                    setCurrentPage(number)
                } else {
                    hideDiv(currentPage);
                    showDiv(number);
                    setCurrentPage(number);
                }
            }
        }
    }

    // Function to call saveChanges from attachments component
    const handleSaveChanges = async () => {
        if (attachmentsRef.current && attachmentsRef.current.saveChanges) {
            console.log('Calling saveChanges from attachments component');
            await attachmentsRef.current.saveChanges();
        } else {
            console.log('Attachments component or saveChanges function not available');
        }
    };

    // Function to handle signature update from AddAttachment component
    const handleSignatureUpdate = (signatureData) => {
        console.log('Signature updated in parent component:', signatureData);
        setSignatureImage(signatureData);
    };

    // Show loading spinner while data is loading
    if (loading || !application) {

        console.log('application state:', application?.state);


        return (
            <div>
                <Navbar />
                <Header userRole={user.user.user_role} applicationState={application?.state} />
                <div className='wrapper'>
                    <div className='boxAppBoard boxWhite'>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '400px',
                            flexDirection: 'column'
                        }}>
                            <div style={{
                                border: '4px solid #f3f3f3',
                                borderTop: '4px solid #3498db',
                                borderRadius: '50%',
                                width: '50px',
                                height: '50px',
                                animation: 'spin 1s linear infinite'
                            }}></div>
                            <p style={{ marginTop: '20px', color: '#666' }}>Loading application data...</p>
                        </div>
                    </div>
                </div>
                <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
            </div>
        );
    }

    return (
        <div>
            <Navbar />
            <Header />
            <div className='wrapper'>
                <div className='boxAppBoard boxWhite'>
                    <div className="stickyFormHeader">
                        <FormHeader
                            applicationName={application?.name || 'Loading...'}
                            applicationId={params.id}
                            userId={application?.user_id || user.user?.id}
                            nextPage={nextPage} previousPage={previousPage}
                            currentPage={currentPage} totalPages={pageIds.length + 1}
                            handleSubmitWithLoading={handleSubmitWithLoading}
                            handlePageChange={handlePageChange}
                            displayInReview={true}
                            userRole={user.user.user_role}
                            json_data={inputFields}
                            pageIds={pageIds}
                            saveChanges={handleSaveChanges}
                        />
                    </div>

                    <div className="boardHeader">


                    </div>

                    <div className={classes['board-content']}>
                        <div className='disarea'>
                            <DescripanciesBox
                                selectedFieldData={selectedFieldData}
                                setSelectedFieldData={setSelectedFieldData}
                                formId={params.id}
                                descrepancies={applicationDicrepancies || {}}
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                                applicationState={application?.state}
                                applicationName={application?.name}
                                userId={application?.user_id || application?.userId}
                            />
                            {!isLoaded && (
                                <div style={{ padding: '20px', textAlign: 'center' }}>
                                    <h3>Loading Form...</h3>
                                    <p>Please wait while the form is being loaded.</p>
                                </div>
                            )}
                            <div>
                                <FormLoader applicationName={application?.name} setFormIds={setFormIds} setPageIds={setPageIds} setIsLoaded={setIsLoaded} />
                                {showAttachments && (
                                    <div>
                                        <AddAttachment
                                            ref={attachmentsRef}
                                            applicationId={params.id}
                                            userId={application?.user_id || user.user?.id}
                                            signatureIds={signatureIds}
                                            setUploadedFiles={setUploadedFiles}
                                            uploadedFiles={uploadedFiles}
                                            applicationState={application?.state || "discrepancies"}
                                            applicationName={application?.name}
                                            jsonData={inputFields}
                                            signatureImage={signatureImage}
                                            onSignatureUpdate={handleSignatureUpdate}
                                            embedded={false}
                                        />
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default DiscrepanciesGbView;

